import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';

const GroundFeildViewModal = (props) => {
  const { isfeildModalOpen, handleclose, selectedGround } = props;
  return (
    <Dialog
      open={!!isfeildModalOpen}
      onClose={handleclose}
      maxWidth='sm'
      fullWidth
      // minHeight='lg'
    >
      <DialogTitle sx={{ textAlign: 'center' }}>Field Rate</DialogTitle>
      <DialogContent>
        {selectedGround?.fields?.length > 0 ? (
          selectedGround.fields.map((field, idx) => (
            <div
              key={field._id || idx}
              style={{
                marginBottom: '1.5rem',
                padding: '1rem',
                border: '1px solid #eee',
                borderRadius: 8,
              }}
            >
              <div style={{ fontWeight: 'bold', fontSize: 18 }}>
                {field.name}
              </div>
              <div>
                Dimensions: {field.length} x {field.width}
                {field.height ? ` x ${field.height}` : ''}
              </div>
              {field.pricing && field.pricing.length > 0 && (
                <div style={{ marginTop: 8 }}>
                  <div>
                    <strong>Off-peak Hour Rates:</strong>{' '}
                    {field.pricing[0].dayPrice}
                  </div>
                  <div>
                    <strong>Peak Hour Rates:</strong>{' '}
                    {field.pricing[0].nightPrice}
                  </div>
                </div>
              )}
              {/* Subfields */}
              {field.subFields && field.subFields.length > 0 && (
                <div style={{ marginTop: 12, marginLeft: 16 }}>
                  <div style={{ fontWeight: 'bold', fontSize: 16 }}>
                    Subfields:
                  </div>
                  {field.subFields.map((sub, subIdx) => (
                    <div
                      key={sub._id || subIdx}
                      style={{
                        marginTop: 8,
                        padding: '0.5rem',
                        border: '1px dashed #ccc',
                        borderRadius: 6,
                      }}
                    >
                      <div style={{ fontWeight: 'bold' }}>{sub.name}</div>
                      {sub.pricing && sub.pricing.length > 0 && (
                        <div style={{ marginLeft: 8 }}>
                          <div>
                            <strong>Off-peak Hour Rates:</strong>{' '}
                            {sub.pricing[0].dayPrice}
                          </div>
                          <div>
                            <strong>Peak Hour Rates:</strong>{' '}
                            {sub.pricing[0].nightPrice}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))
        ) : (
          <div>No fields found for this ground.</div>
        )}
      </DialogContent>
      <div
        style={{ display: 'flex', justifyContent: 'center', padding: '1rem' }}
      >
        <button
          onClick={handleclose}
          style={{
            padding: '8px 24px',
            background: '#0C7240',
            color: 'white',
            border: 'none',
            borderRadius: 4,
            fontSize: 16,
            cursor: 'pointer',
          }}
        >
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default GroundFeildViewModal;
